export const projectsData = [
  {
    id: 1,
    language: "javascript",
    desc: "This UI i got from frontend mentor and after completing the front-end part, i thought why am I not making it functional like real life form . so i made it functional. this form is made by [ React-JS ] and used a API called - [ Email-JS ].",
    title: "A React Form",
    category: "javascript",
    link: "https://github.com/touhid-hossain/a-react-form",
  },
  {
    id: 2,
    language: "html - css",
    desc: "Its a landing page about Agro farms.Those who does agro business, it might comes handy for them!",
    title: "Agriculture Landing Page",
    category: "css",
    link: "https://github.com/touhid-hossain/gaea-project",
  },
  {
    id: 3,
    language: "html - css - javascript",
    desc: "Its a mini product landing page which i found quite complex while working on it.",
    title: "Product Landing Page",
    category: "html",
    link: "https://github.com/touhid-hossain/product-landing-page",
  },
  {
    id: 4,
    language: "html - css - javascript",
    desc: "Its a landing about Banking section. it was an interesting project because its an collab project with friends.",
    title: "Easybank Landing Page",
    category: "css",
    link: "https://github.com/touhid-hossain/easybank-landing-page",
  },
  {
    id: 5,
    language: "html - css - bootstrap",
    desc: "Its a FAQ page. it was a challenge from FrontendMentor.",
    title: "FAQ Page",
    category: "html",
    link: "https://github.com/touhid-hossain/faq-page",
  },
  {
    id: 6,
    language: "html - tailwind-css",
    desc: "It's a landing page that has been built with tailwind-css.",
    title: "Tailwind Landing Page",
    category: "css",
    link: "https://github.com/touhid-hossain/tailwind-css",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "html",
  },
  {
    name: "css",
  },
  {
    name: "javascript",
  },
];
